<template>
  <div class="ToasterComponent">
    <TransitionGroup name="list">
      <BaseToast
        v-for="toast in toasts"
        :key="toast.id"
        :message="toast.message"
        :type="toast.type"
        @close="emit('close', toast.id)"
        @pause="emit('pause', toast.id)"
        @resume="emit('resume', toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import BaseToast from '@/modules/core/components/ui/BaseToast.vue'
import type Toast from '../../models/Toast'

interface PropsInterface {
  toasts: Toast[]
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const emit = defineEmits(['close', 'pause', 'resume'])

watch(
  () => props.toasts,
  () => window.scrollTo({ top: 0, behavior: 'smooth' }),
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.ToasterComponent {
  width: $size-full;
  max-width: $size-1440;
  margin: 0 auto;

  .BaseToast:not(:last-child) {
    margin-bottom: $spacing-xs;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s ease;
  }

  .list-enter-from,
  .list-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
</style>
